import React, { useEffect, useState } from 'react'
import { Button, Dimmer, GridColumn, GridRow, Icon, Loader, Message, Modal, Table } from 'semantic-ui-react'
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'

import SwiperCore, { Navigation, Pagination } from 'swiper/core'

import 'swiper/swiper.min.css'
import PlaceServiceAPI from '../../../apis/PlaceServiceAPI'
import { PlacenameDocument } from '../slice'

import './PlacenameTab.css'

// install Swiper modules
SwiperCore.use([Pagination, Navigation])

type tab4 = {
  placenameMedia: PlacenameDocument[],
  isLoading: boolean
}

export default function PlacenameTab4({ placenameMedia, isLoading }: tab4) {
  const [openModal, setOpenModal] = useState(false)
  const [mediaUrl, setMediaUrl] = useState<string>()
  const [fileType, setFileType] = useState('pdf')
  const [mediaLoader, setMediaLoader] = useState(true)
  const [hasPlaceMedia, setHasPlaceMedia] = useState(false)
  const [showMessage, setShowMessage] = useState(false)
  const [hasDownloadButton, setHasDownloadButton] = useState(false)

  useEffect(() => {
    if (placenameMedia && placenameMedia.filter(m => m.category !== 'MEDIA_AUDIO_PRONUNCIATION').length > 0) {
      setHasPlaceMedia(true)
      setShowMessage(false)
    } else {
      setShowMessage(true)
      setHasPlaceMedia(false)
    }
  }, [placenameMedia])

  function handleOnClick(media: PlacenameDocument) {
    if (media.mediaUrl) {
      createHyperLink(media.mediaUrl, '')
    } else {
      PlaceServiceAPI.fetchPlacenameDocumentFor(media.placeId, media.mediaId).then(v => {
        if (v) {
          let blob = new Blob([v], { type: media.mimeType })
          let data = URL.createObjectURL(blob)
          setMediaUrl(data)
          setHasDownloadButton(true)
        }
      })
      setOpenModal(true)
    }
    setFileType(media.fileType)
  }

  function download(media: PlacenameDocument) {
    let data
    if (!media.mediaUrl) {
      PlaceServiceAPI.fetchPlacenameDocumentFor(media.placeId, media.mediaId).then(v => {
        if (v) {
          let blob = new Blob([v], { type: media.mimeType })
          data = URL.createObjectURL(blob)
          createHyperLink(data, media.mediaId + '.' + media.fileType)
        }
      })
    } else {
      data = media.mediaUrl
      createHyperLink(data, '')
    }

  }

  function createHyperLink(data: string, fileName: string) {
    if (data) {
      let link = document.createElement('a')
      link.href = data
      link.target = '_blank'
      link.download = fileName
      link.click()
      URL.revokeObjectURL(data)
    }
  }

  const handleMediaLoading = () => {
    setMediaLoader(false)
  }

  function modalClose() {
    setOpenModal(false)
    setMediaLoader(true)
  }

  function displayMedia() {
    return (
      <React.Fragment>
        <Loader active={isLoading}>Loading</Loader>

        {(showMessage && !isLoading) &&
            <Message
                className="no-media-message"
                icon="file"
                header="No media attached"
                content="Selected place has no media attached."
            />}

        {(hasPlaceMedia && placenameMedia.filter(m => m.category !== 'MEDIA_AUDIO_PRONUNCIATION').length > 0) &&
            <div>
                <GridRow className="placenameDetailsL1Row">
                    <GridColumn width={16} className="placenameDetailsFieldLabel">
                        <p>Media</p>
                    </GridColumn>
                </GridRow>
                <Table celled padded className={'details-table'}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Document</Table.HeaderCell>
                            <Table.HeaderCell></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      {
                        placenameMedia.filter(m => m.category !== 'MEDIA_AUDIO_PRONUNCIATION').map(media => (
                          <Table.Row key={media.mediaId}>
                            <Table.Cell>
                              <div className="media-content">
                                <div id={media.mediaId.toString()}>
                                  {(media.fileType === 'pdf') &&
                                      <Icon name="file pdf outline" color="red" size={'large'}/>}
                                  {(media.fileType !== 'pdf' && media.mimeType !== 'text/uri-list' && media.fileType) &&
                                      <Icon name="file image outline" color="green" size={'large'}/>}
                                  {(media.mimeType === 'text/uri-list') &&
                                      <Icon name="file outline" color="orange" size={'large'}/>}
                                  {(media.mimeType !== 'text/uri-list') &&
                                      <div> {media.friendlyCategory + (media.fileType ? ' (' + media.fileType + ')' : '')} </div>}
                                  {(media.mimeType === 'text/uri-list') && <div> {media.friendlyCategory} </div>}
                                </div>
                              </div>
                            </Table.Cell>
                            <Table.Cell>
                              <div className="media-content">
                                <Button onClick={() => handleOnClick(media)}>View</Button>
                                {!media.mediaUrl && <Button onClick={() => download(media)}>Download</Button>}
                              </div>
                            </Table.Cell>
                          </Table.Row>
                        ))
                      }

                    </Table.Body>
                </Table>
            </div>
        }
      </React.Fragment>
    )
  }

  function mediaModal() {
    return (
      <React.Fragment>
        <Modal id="media-modal"
               closeIcon
               open={openModal}
               onClose={() => modalClose()}
               size="large">
          <Dimmer active={mediaLoader}>
            <Loader>Loading</Loader>
          </Dimmer>
          {(fileType === 'pdf') &&
              <object data={mediaUrl} width="100%" height="100%" onLoad={() => handleMediaLoading()}/>
          }
          {(fileType && fileType !== 'pdf') &&
              <div className="mediaImage">
                  <div className="modal-download-btn">
                    {hasDownloadButton && <a href={mediaUrl} download><Button>Download</Button></a>}
                  </div>

                  <img src={mediaUrl} onLoad={() => handleMediaLoading()}/>
              </div>
          }
        </Modal>
      </React.Fragment>
    )
  }

  function displayValidPlacenameFields() {
    return (
      <React.Fragment>
        {displayMedia()}
        {mediaModal()}
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      {displayValidPlacenameFields()}
    </React.Fragment>
  )
}

